<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5 4.5C20.5 3.94772 20.0523 3.5 19.5 3.5H4.5C3.94772 3.5 3.5 3.94772 3.5 4.5V19.5C3.5 20.0523 3.94772 20.5 4.5 20.5H19.5C20.0523 20.5 20.5 20.0523 20.5 19.5V4.5ZM22.5 19.5C22.5 21.1569 21.1569 22.5 19.5 22.5H4.5C2.84315 22.5 1.5 21.1569 1.5 19.5V4.5C1.5 2.84315 2.84315 1.5 4.5 1.5H19.5C21.1569 1.5 22.5 2.84315 22.5 4.5V19.5Z"
      fill="currentColor"
    />
    <path
      d="M21 14V16H3V14H21Z"
      fill="currentColor"
    />
    <path
      d="M21 8V10H3V8H21Z"
      fill="currentColor"
    />
    <path
      d="M10 21H8V3H10V21Z"
      fill="currentColor"
    />
    <path
      d="M16 21H14V3H16V21Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'ChartTable' };
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
/>
